import {
  Box,
  Button,
  Center,
  Heading,
  HStack,
  Image,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useState } from 'react';

import { toaster } from '#src/components/ui/toaster';
import { useUser } from '#src/providers/user-provider';

export function LoginPage() {
  const { login } = useUser();
  const [error, setError] = useState<string | null>(null);
  const [userEmail, setUserEmail] = useState('');

  const attemptLogin = () => {
    setError(null);
    const trimmed = userEmail.trim();
    if (!trimmed) {
      setError('Please enter your email address.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError('Please enter a valid email address.');
      return;
    }
    login(trimmed);
    toaster.create({
      title: 'Welcome',
      description: `Signed in as ${trimmed}`,
      type: 'success',
      duration: 3000,
      closable: true,
    });
  };

  return (
    <Center minH="100vh" bg="gray.50" p={4}>
      <Box bg="white" shadow="lg" borderRadius="lg" p={8} w="full" maxW="md">
        <VStack gap={6} align="stretch">
          <VStack gap={1}>
            <HStack gap={3} align="center">
              <Image src="/icon.svg" alt="Note Plan Logo" w={8} h={8} />
              <Heading size="lg" color="blue.600">
                Note Plan
              </Heading>
            </HStack>
            <Text fontSize="sm" color="gray.500">
              Enter your email to continue
            </Text>
          </VStack>
          <Box>
            <Input
              value={userEmail}
              onChange={(e) => {
                setUserEmail(e.target.value);
                setError(null);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  attemptLogin();
                }
              }}
              placeholder="you@example.com"
              type="email"
              size="lg"
              autoComplete="email"
              autoFocus
              aria-invalid={!!error}
              aria-describedby={error ? 'login-error' : undefined}
            />
            {error && (
              <Text
                id="login-error"
                mt={2}
                fontSize="sm"
                color="red.600"
                role="alert"
              >
                {error}
              </Text>
            )}
          </Box>
          <Button
            type="button"
            colorScheme="blue"
            size="lg"
            width="full"
            onClick={attemptLogin}
          >
            Continue
          </Button>
        </VStack>
      </Box>
    </Center>
  );
}
